import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../core/modules/shared.module';

import {FuseOrganisationsComponent} from './organisations.component';

const routes = [{path: 'organisations', component: FuseOrganisationsComponent}];

@NgModule({
  declarations: [FuseOrganisationsComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [FuseOrganisationsComponent]
})

export class FuseOrganisationsModule {}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/organisations/organisations.module.ts